import { parse } from 'date-fns';

const FORMAT = 'yyyy-MM-dd';

export const parseDiaryDateStr = (dateStr: string): Date => {
  return parse(dateStr, FORMAT, new Date());
};
